import React, { useState } from "react";
import PropTypes from "prop-types";
import { Flex, Box, Button } from "rebass";
import { getLocalizedString } from "../../utils";
import Eye from "../../icons/Eye";
import DotsRight from "../../icons/DotsRight";
import { theme } from "../../utils";

function Settings({ hideSettings }) {
  const localSettingsStr = localStorage.getItem("b2b_settings");
  const settingsList = localSettingsStr ? localSettingsStr.split("_*_") : [];
  const [isFullWidth, setIsFullWidth] = useState(
    settingsList.length > 0 ? settingsList[0] === "true" : false,
  );
  const [isColumn, setIsColumn] = useState(
    settingsList.length > 0 ? settingsList[1] === "true" : false,
  );
  const [compile, setCompile] = useState(
    settingsList.length > 0 ? Number(settingsList[2]) : 1,
  );

  const saveSettings = () => {
    const settingsStr =
      String(isFullWidth) + "_*_" + String(isColumn) + "_*_" + String(compile);
    localStorage.setItem("b2b_settings", settingsStr);
    hideSettings();
  };

  return (
    <Flex
      style={{
        position: "absolute",
        width: "300px",
        top: "65px",
        right: 0,
        zIndex: 10,
        backgroundColor: "#F3F3F3",
        padding: "25px 20px",
      }}
      flexDirection="column"
    >
      <Flex style={{ marginLeft: "25px" }}>
        <Eye />
        <Box
          style={{
            fontSize: "20px",
            textTransform: "uppercase",
            color: theme.settingTextColor,
            marginLeft: "25px",
            marginBottom: "15px",
          }}
        >
          view
        </Box>
      </Flex>
      <Box
        style={{
          width: "100%",
          height: "1px",
          borderBottom: `1px solid ${theme.settingTextColor}`,
        }}
      ></Box>
      <Box
        style={{
          fontSize: "20px",
          color: theme.settingTextColor,
          marginLeft: "25px",
          marginTop: "22px",
          marginBottom: "30px",
        }}
        sx={{
          "& input": {
            width: "15px",
            height: "15px",
            marginRight: "20px",
          },
        }}
      >
        <Box>
          <input
            type="checkbox"
            checked={isFullWidth}
            name="isFullWidth"
            onChange={() => setIsFullWidth(!isFullWidth)}
          />
          Full Width
        </Box>
        <Box>
          <input
            type="checkbox"
            checked={isColumn}
            name="isColumn"
            onChange={() => setIsColumn(!isColumn)}
          />
          Column
        </Box>
      </Box>
      <Box
        style={{
          width: "100%",
          height: "1px",
          borderBottom: `1px solid ${theme.settingTextColor}`,
        }}
      ></Box>
      <Flex style={{ marginTop: "20px", marginLeft: "25px" }}>
        <DotsRight />
        <Box
          style={{
            fontSize: "20px",
            textTransform: "uppercase",
            color: theme.settingTextColor,
            marginBottom: "15px",
          }}
        >
          autocompile
        </Box>
      </Flex>
      <Box>
        <input
          name="compile"
          placeholder="INSERT VALUE"
          value={compile}
          onChange={(e) => setCompile(Number(e.target.value))}
          style={{
            width: "90%",
            marginLeft: "5%",
            padding: "18px 16px 22px",
            backgroundColor: "#FFF",
            color: "#00000099",
            borderRadius: "4px 4px 0 0",
            letterSpacing: "0.13px",
            lineHeight: "16px",
            textTransform: "uppercase",
          }}
        />
        <Box
          style={{
            marginLeft: "25px",
            marginTop: "12px",
            marginBottom: "22px",
            color: "#000",
            letterSpacing: "0.13px",
            fontSize: "14px",
            lineHeight: "21px",
          }}
        >
          * Default setting = 1
        </Box>
      </Box>
      <Flex>
        <button
          onClick={() => saveSettings()}
          style={{
            width: "100%",
            backgroundColor: "#232323",
            borderRadius: "5px",
            color: "#F3F3F3",
            fontSize: "16px",
            letterSpacing: "1.25px",
            padding: "16px 0",
            textTransform: "uppercase",
          }}
        >
          save
        </button>
      </Flex>
    </Flex>
  );
}

Settings.propTypes = {
  hideSettings: PropTypes.func,
};
export { Settings };
